import {
    HOME_LOGOUT
} from './actionTypes';

export function logout() {
    return {
        type: HOME_LOGOUT
    }
}